export interface GetIntermediateLoginTokenRequest {
  email: string
}

export interface GetIntermediateLoginTokenResponse {
  intermediate_login_token: string
}
